import {mapGetters} from "vuex";
import TooltipBZ from '@/views/blogger/records/components/TooltipBZ.vue'
import VTableCard from '@/vuetify_custom/v-table-card'
import VRippleCol from '@/vuetify_custom/v-ripple-col';
import {sale_status_hash} from '@/views/openShopApply/fields.js'
import {THRID} from './constants'
import { VSpacer } from 'vuetify/lib'
import {getThirdPartyShopTransferRecordsApi} from '@/views/openShopApply/services.js'
import styles from './index.module.less'
export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        target: {
            type: Object,
            default: () => ({})
        },
        entryType: {
          type: String,
        }
    },
    data() {
      return {
        principal_changes: [],
        team_changes: []
      }
    },
    computed: {
      ...mapGetters({
        teams_hash: 'async/root_teams_hash',
      }),
        tableCardFields() {
            let base = [
                 {
                   label: '开店平台：',
                   key: 'shop_platform',
                   type: 'text_field',
                 },
                 {
                   label: '店铺类型：',
                   key: 'shop_type',
                   type: 'text_field'
                 },
                 {
                   label: '店铺名称：',
                   key: 'shop_name',
                   type: 'text_field'
                 },
                 {
                  label: '售卖状态：',
                  key: 'sale_status',
                  type: 'text_field',
                  show: this.entryType !== THRID
                },
                 {
                  label: '商城编号：',
                  key: 'mall_code',
                  type: 'text_field',
                  show: this.entryType === THRID
                },
                {
                  label: '开店流程编号：',
                  key: 'opening_shop_order_uid',
                  type: 'text_field',
                  show: this.entryType === THRID
                },
                {
                  label: '开店团队：',
                  key: 'kd_team',
                  type: 'text_field',
                  show: this.entryType === THRID
                },
                 {
                   label: '押金：',
                   key: 'deposit',
                   type: 'money_field',
                 },
                 {
                   label: '认证款：',
                   key: 'certification_cost',
                   type: 'money_field'
                 },
                 {
                  label: '财务子账号信息：',
                  key: 'sub_account_info',
                  type: 'text_field'
                 },
                 {
                    label: '预计退回时间：',
                    key: 'refund_at',
                    type: 'date_field',
                    formate: 'YYYY-MM-DD',
                    show: this.target && this.target.certification_cost
                  },
                 {
                  label: '备注',
                  key: 'desc',
                  type: 'text_field',
                  show: this.entryType === THRID
                 }
               
           ]
           base = base.map(i => {
             if (i.show === undefined) {
              i.show = true
             }
             return i
           })
            return base.filter(i => i.show)
        }
    },
    created() {
       getThirdPartyShopTransferRecordsApi({id: this.target.id}).then(res => {
          this.principal_changes = res.principal_changes
          this.team_changes = res.team_changes
       })
    },
    render() {
        const _this = this
        return <VTableCard 
                    sub-title="开店信息【财务】"
                    value={_this.target}
                    fields={_this.tableCardFields}
                    cols={4}
                    scopedSlots={{
                      sale_status({field, value}) {
                        console.log('value', value)
                        return <VRippleCol
                        >
                          <span style="white-space:nowrap">{field.label}</span>
                          <VSpacer/>
                          <span style={{
                              float: 'right'
                          }}>{ sale_status_hash[value.sale_status] ? sale_status_hash[value.sale_status].label : '-'}</span>
                        </VRippleCol>
                      },  
                        real_product({field, value}) {
                            return <VRippleCol
                          >
                            <span style="white-space:nowrap">{field.label}</span>
                            <VSpacer/>
                            <span style={{
                                float: 'right'
                            }}>{value.real_product ? '是' : '否'}</span>
                          </VRippleCol>
                        },
                        kd_team: ({field}) => {
                          const team_id = (_this.target || {})['team_id']
                          const team = (this.teams_hash || {})[team_id] || {}
                          const has_principal_changes = this.principal_changes.length !== 0 
                          const has_teams_changes = this.team_changes.length !== 0
                          const has_no_history = !has_principal_changes && !has_teams_changes
                          return (<VRippleCol
                            md="12"
                            cols="12"
                          >
                            {field.label}
                            <VSpacer/>
                            <div>
                              <p class={styles['p-no-margin']}>
                                {!!has_no_history && <span>    {team.name}</span>}
                                {!has_no_history && <TooltipBZ 
                                  top
                                  render={() => {
                                    return <div>
                                      {has_principal_changes && <div>
                                        <div>店铺负责人：</div>
                                        <div>
                                        {this.principal_changes.map(i => {
                                          return <div key={`${i.begin_at}-${i.end_at}`}>
                                            <span>{i.begin_at}-{i.end_at}</span>，
                                            <span>{i.principal_name}</span>
                                          </div>
                                        })}
                                        </div>
                                      </div>}
                                      {has_teams_changes && <div>
                                        <div>开店团队：</div>
                                        <div>
                                        {this.team_changes.map(i => {
                                          return <div key={`${i.begin_at}-${i.end_at}`}>
                                            <span>{i.begin_at}-{i.end_at}</span>，
                                            <span>{i.team_name}</span>
                                          </div>
                                        })}
                                        </div>
                                      </div>}
                                    </div>
                                  }}
                                >
                                  {team.name}
                                </TooltipBZ>}
                              </p>
                            </div>
                          </VRippleCol>)
                        },
                    }}
                />
    }
}